export default __webpack_public_path__ + "static/media/favourite-border.6d0a1096.svg";